import React from 'react'
import { useStateValue } from '@State'
import { readingCheckboxId } from './payload'

export const ReadingLinksContainer = ({
  selectedResourceIds,
  handleCheck,
  selectedTitleIds,
  handleTitleCheck,
}) => {
  const [currentState] = useStateValue()

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between">
        <div>
          {currentState.connectedCourses.map(( course, outer_idx ) => {
            return (
              <div key={`${course.coursenum}-titlepage-key`}>
                <h2>{course.bookTitle}</h2>
                <h3>Title Page Link</h3>
                <div style={{ marginLeft: '1.25rem' }}>
                  <input
                    type="checkbox"
                    id={`titlePageLink-${course.coursenum}-id`}
                    value={`titlepage-${course.coursenum}`}
                    onChange={handleTitleCheck}
                    checked={selectedTitleIds.includes(
                      `titlepage-${course.coursenum}-${outer_idx}`
                    )}
                    data-sort-idx={outer_idx}
                  />
                  <label
                    className="ml-2"
                    htmlFor={`titlePageLink-${course.coursenum}-id`}
                  >{`${course.bookTitle} Title Page`}</label>
                </div>
                <h3>Reading Links</h3>
                {course.bookNodes.map((node, inner_idx) => {
                  if (node.isSelectable) {
                    return (
                      <div
                        key={`${course.coursenum}-${inner_idx}`}
                        style={{ marginLeft: `${Math.min(node.depth * 2, 6)}rem` }}
                      >
                        <input
                          type="checkbox"
                          id={readingCheckboxId(course.coursenum, node.id)}
                          value={node.id}
                          onChange={handleCheck}
                          checked={selectedResourceIds.includes(`${node.id}::${outer_idx}::${inner_idx}`)}
                          data-sort-idx={`${outer_idx}::${inner_idx}`}
                        />
                        <label
                          className="ml-2"
                          htmlFor={readingCheckboxId(course.coursenum, node.id)}
                        >
                          {node.title}
                        </label>
                      </div>
                    )
                  } else {
                    return (
                      <div
                        key={`${course.coursenum}-${inner_idx}`}
                        style={{ marginLeft: `${Math.min(node.depth, 3)}rem` }}
                      >
                        <h4>{node.title}</h4>
                      </div>
                    )
                  }
                })}
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}
